export * from './logo.component';
export * from './logo.module';
